import { render, staticRenderFns } from "./NetworkMonitor.vue?vue&type=template&id=482f26e0&scoped=true"
import script from "./NetworkMonitor.vue?vue&type=script&lang=js"
export * from "./NetworkMonitor.vue?vue&type=script&lang=js"
import style0 from "./NetworkMonitor.vue?vue&type=style&index=0&id=482f26e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "482f26e0",
  null
  
)

export default component.exports